export default __webpack_public_path__ + "static/media/Cybersecurity_WebPage_banner_no_text_mobile.30fb0751.jpg";